// Store de Pinia para Worktime Client
// Migrado desde Vuex store/modules/worktime.js
// Mantiene la misma API para compatibilidad

import type { DeviceInfo, Turn } from '@wkt/api/gwt/gwtDTO';
import { defineStore } from 'pinia';

interface WorktimeState {
  uuid: string | null;
  deviceInfo: DeviceInfo;
  turns: Turn[];
  serviceVersion: string;
}

export const useWorktimeStore = defineStore('worktime', {
  state: (): WorktimeState => ({
    uuid: null,
    deviceInfo: {} as DeviceInfo,
    turns: [],
    serviceVersion: 'unknown',
  }),

  getters: {
    // Getters compatibles con la API anterior
    getUuid: (state) => state.uuid,
    getDeviceInfo: (state) => state.deviceInfo,
    getTurns: (state) => state.turns,
    getServiceVersion: (state) => state.serviceVersion,
  },

  actions: {
    // Actions que mantienen los mismos nombres que las mutations de Vuex
    setUuid(uuid: string) {
      this.uuid = uuid
    },

    setDeviceInfo(deviceInfo: DeviceInfo) {
      this.deviceInfo = deviceInfo
    },

    setTurns(turns: Turn[]) {
      this.turns = turns
    },

    setServiceVersion(serviceVersion: string) {
      this.serviceVersion = serviceVersion
    },
  },
})
